import React, { useEffect, useState, memo, useRef } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'

import bradyLogo from 'Assets/brady_logo_blue_288_svg.svg'
import bradyLogoWhite from 'Assets/brady-logo-white.svg'
import { OperationsApi } from 'Services'
import { StyledHeader } from './header-logo.styles'

function Header({
  children,
  getAlerts = () => { },
  menu = false,
  onMenuToggle = false,
  title = ""
}) {
  const [logo, setLogo] = useState(undefined)
  const organizationid = useSelector(({ user }) => user?.selectedOrganizationId)
  const theme = useSelector(({ user }) => user?.theme)
  const isDarkMode = theme?.black === '#000 !important' || theme?.isDark
  const defaultLogo = isDarkMode ? bradyLogoWhite : bradyLogo
  const cancellationToken = useRef()

  useEffect(() => {
    getLogo(organizationid, defaultLogo)
    return function cleanUp() {
      cancellationToken.current?.cancel()
    }
  }, [organizationid, defaultLogo])

  useEffect(() => {
    getAlerts()
  }, [])

  async function getLogo(orgId, fallbackLogo) {
    try {
      setLogo(fallbackLogo)
      const cancelToken = axios.CancelToken.source()
      cancellationToken.current = cancelToken
      const response = await OperationsApi.getLogo(orgId)
      if (response.ok) {
        setLogo(response.data?.data)
      } else {
        setLogo(fallbackLogo)
      }
    } catch (error) {
      setLogo(fallbackLogo)
    }
  }
  return (
    <StyledHeader
      imageurl={logo}
      title={title}
      menu={menu}
      onMenuToggle={onMenuToggle}
    >
      {children}
    </StyledHeader>
  )
}

export default memo(Header)
